import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationKR from './locales/kr/translation.json';
import translationJA from './locales/ja/translation.json';

export const LANGUAGES = {
  EN: 'en',
  KR: 'kr',
  JA: 'ja',
};

const resources = {
  [LANGUAGES.EN]: {
    translation: translationEN,
  },
  [LANGUAGES.KR]: {
    translation: translationKR,
  },
  [LANGUAGES.JA]: {
    translation: translationJA,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .on('languageChanged', (lng) => {
    document.documentElement.setAttribute('lang', lng);
  })
  .init({
    resources,
    fallbackLng: {
      ko: ['kr'],
      'ko-KR': ['kr'],
      default: ['en'],
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
